const base = {
  'PHPPath':'https://joyworkapi.lshmnc.com.cn/public/index.php/',
  // 'PHPPath':'http://localhost/joyworkapi/public/index.php/',
  // 'PHPPath':'https://joyworkapi-qa.lshmnc.com.cn/public/index.php/',
}
module.exports = {
  base:base
}


// WEBPACK FOOTER //
// ./src/api/base.js